module.exports = __webpack_public_path__ + "static/media/sweepMidground.43914e9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Sweep/sweepMidground.svg
// module id = 935
// module chunks = 0